import { render, staticRenderFns } from "./PagePlace.vue?vue&type=template&id=64388088&"
import script from "./PagePlace.vue?vue&type=script&lang=js&"
export * from "./PagePlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64388088')) {
      api.createRecord('64388088', component.options)
    } else {
      api.reload('64388088', component.options)
    }
    module.hot.accept("./PagePlace.vue?vue&type=template&id=64388088&", function () {
      api.rerender('64388088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/place/PagePlace.vue"
export default component.exports